import React from 'react';

import SearchBar from './SearchBar';
import FilterPanel from './FilterPanel';

export default function SideBar ({onFiltersChange, handleSearch}){

    return(
        <section className='w-full'>
            <SearchBar handleSearch={handleSearch}/>
            <FilterPanel onFiltersChange={onFiltersChange}/>
        </section>
    )

}